import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const BankServices = {
  create: async (data) => {
    const response = await apiService.post(
      `/${slug}/bank`,
      data
    );
    return response.data;
  },
  createDeposit: async (data) => {
    const response = await apiService.post(
      `/${slug}/bank/deposit`,
      data
    );
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/bank`);
    return response.data;
  },
  getBankStatement: async (id) => {
    const response = await apiService.get(`/${slug}/bank/${id}/detailswithtransactions`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/purchase/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/${slug}/bank/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/bank/${id}`);
    return response.data;
  },
};

export default BankServices;
